module.exports = __webpack_public_path__ + "static/appointer-logo-6d32240ea25bf1894206be7c791d55a8.png";